import React from 'react';
import {
  Autocomplete,
  Box,
  TextField,
  Typography,
  CircularProgress
} from '@mui/material';

interface CustomAutocompleteProps {
  value: Record<string, string | number> | null;
  error: boolean;
  options: Array<Record<string, string | number>>;
  onChange: (newValue: Record<string, string | number> | null) => void;
  onInputChange?: (event: React.ChangeEvent<{}>, value: string) => void;
  label: string;
  isEdit?: boolean;
  loading?: boolean;
}

const getOptionLabel = (option: Record<string, string | number>): string => {
  if (option.displayName) {
    return option.displayName as string;
  }
  if (option.name) {
    return option.name as string;
  } else {
    return '';
  }
};

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
  value,
  error,
  options,
  onChange,
  onInputChange,
  label,
  isEdit,
  loading = false
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
      }}
    >
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 500,
          color: '#44474E'
        }}
      >
        {label}
      </Typography>
      <Autocomplete
        value={value}
        disabled={isEdit}
        onChange={(_event, newValue) => {
          onChange(newValue);
        }}
        onInputChange={onInputChange}
        options={options}
        getOptionLabel={getOptionLabel}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              )
            }}
          />
        )}
      />
      {error && (
        <Typography
          sx={{
            color: 'red',
            fontSize: '10px'
          }}
        >
          Select a {label.toLowerCase()}
        </Typography>
      )}
    </Box>
  );
};

export default CustomAutocomplete;
